module.exports = __webpack_public_path__ + "img/1f9ea.1b60b3c.svg";